<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    forecaster: {
      type: String,
      required: true
    },
    forecasterInfo: {
      type: Object,
      default: null
    },
  });

  const forecasterBioUrl = computed(() => props.forecasterInfo ? `https://tempest.earth/forecasters/${props.forecasterInfo.bio_slug}/` : null);

</script>

<template>
  <p v-if="forecasterBioUrl" class="jwx-pro-forecast__credits jwx-font-size-sm">Prepared by meteorologist <a :href="forecasterBioUrl" target="_blank" class="jwx-pro-forecast__credits-author">{{ props.forecaster }}</a></p>
  <p v-else class="jwx-pro-forecast__credits jwx-font-size-sm">Prepared by meteorologist <span class="jwx-pro-forecast__credits-author">{{ props.forecaster }}</span></p>
</template>